import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { getListUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const EventEnrollListTriggerAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: diagnosisReason.changeStatus === 'ADDED' ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.EVENT_ENROLL_LIST_TRIGGER.added_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.EVENT_ENROLL_LIST_TRIGGER.removed_jsx',
      elements: {
        ViewLink: UILink,
        ObjectNameLabel,
        ListNameLabel,
        b: 'b'
      },
      options: {
        objectName: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        },
        listName: {
          portalId: selectedEnrollment.portalId,
          listId: diagnosisReason.listId,
          showId: getIsInternal()
        },
        viewLink: {
          external: true,
          href: getListUrl({
            portalId: selectedEnrollment.portalId,
            listId: diagnosisReason.listId
          })
        }
      }
    })
  });
};
export default EventEnrollListTriggerAnalysisDetails;